import { Component, OnInit } from '@angular/core';
import { GamesGroupService, GroupType, IGroupSummary, ProgressStatus, SortFn, TriviaGroupSummary } from '@fgb/core';
import { filterBy, sortBy } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { Observable } from 'rxjs';

enum GAME_TAB {
  LIVE_UPCOMING = 0,
  RESULTS = 1,
}

@Component({
  selector: 'fgb-quiz-play-page',
  templateUrl: './quiz-play-page.component.html',
  styleUrl: './quiz-page.component.scss',
})
export class QuizPlayPageComponent implements OnInit {
  gamesGroup$: Observable<TriviaGroupSummary[]>;
  groupType = GroupType.Trivia;
  liveUpcomingTab: boolean = false;
  filters: any = [];
  sort: SortFn[] = [];

  constructor(private gamesGroupService: GamesGroupService) {}
  ngOnInit(): void {
    this.gamesGroup$ = this.gamesGroupService.fetchTriviaGroups();
  }

  onTabChage(tab: GAME_TAB): void {
    const defaultSort: SortFn[] = [
      (a, b) => {
        const statusOrder = [
          ProgressStatus.InProgress,
          'Featured',
          ProgressStatus.NotStarted,
          'ComingSoon',
          ProgressStatus.Completed,
          'Locked',
        ];
        const getStatusIndex = (group: IGroupSummary) => {
          if (group.Locked) {
            return statusOrder.indexOf('Locked');
          }
          if (group.Status === ProgressStatus.NotStarted && group.ComingSoon) {
            return statusOrder.indexOf('ComingSoon');
          }
          if (group.Status === ProgressStatus.NotStarted && group.Featured) {
            return statusOrder.indexOf('Featured');
          }
          return statusOrder.indexOf(group.Status);
        };
        return getStatusIndex(a) - getStatusIndex(b);
      },
    ];
    if (tab === GAME_TAB.LIVE_UPCOMING) {
      this.filters = [filterBy({ EntityGroupCompleted: false }), filterBy({ Status: ProgressStatus.Completed }, '!=')];
      this.sort = [...defaultSort, sortBy('StartDate', 'asc', { type: 'date' })];
      this.liveUpcomingTab = true;
    } else if (tab === GAME_TAB.RESULTS) {
      this.filters = [
        filterBy({ EntityGroupCompleted: true }),
        { operator: 'or' },
        filterBy({ Status: ProgressStatus.Completed }),
      ];
      this.sort = [...defaultSort, sortBy('CompletionDate', 'desc', { type: 'date' })];
      this.liveUpcomingTab = false;
    }
  }
}

@Component({
  selector: 'fgb-quiz-page',
  templateUrl: './quiz-page.component.html',
  styleUrl: './quiz-page.component.scss',
})
export class QuizPageComponent implements OnInit {
  ngOnInit(): void {}
}
